import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useLocation, useHistory } from 'react-router-dom';
import ButtonBase from '@material-ui/core/ButtonBase';
import Badge from 'components/Badge';
import Mixpanel from 'utils/mixpanelService';
import { getImageFile } from 'utils/stringUtils';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    display: 'block',
    border: '1px solid #E9ECED',
    borderRadius: 4,
  },
  root: {
    background: '#fff',
    borderRadius: 4,
    width: '100%',
    height: 80,
    display: 'flex',
    overflow: 'hidden',
    zIndex: 99,
  },
  bigCardRoot: {
    height: 129,
  },
  bigCardImgWrapper: {
    paddingLeft: 16,
    paddingTop: 16,
    width: 80,
    height: '100%',
  },
  imgBG: {
    width: 80,
    height: 80,
    background: props => `url(${props.imgUrl}) no-repeat center / cover`,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
  },
  bigCardImgBG: {
    width: 64,
    height: 64,
    borderRadius: 4,
  },
  title: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: '0.875rem',
    lineHeight: '1.35',
    letterSpacing: 0,
    display: '-webkit-box',
    '-webkit-line-clamp': '1',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxHeight: '1.18125rem',
  },
  bigCardTitle: {
    '-webkit-line-clamp': '3',
    maxHeight: '3.54375rem',
  },
  description: {
    ...theme.typography.pxSmall,
    letterSpacing: 0,
    lineHeight: '1',
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  info: {
    padding: '4px 12px',
  },
  bigCardInfo: {
    paddingTop: 16,
  },
  badgeWrapper: {
    '& div': {
      width: '100%',
      margin: 0,
      height: 20,
    },
  },
}));

const HorizontalTopicCard = ({ item, isBigCard }) => {
  const location = useLocation();
  const history = useHistory();

  const {
    fields,
    fields: { name, url, slug, title, article, description },
    sys: { id },
  } = item;

  const redirect = () => {
    const pageName = location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';

    Mixpanel.track('Resource Card - Clicked', {
      name: name || title,
      type: 'topics',
      page: finalPageName,
      path: location.pathname.split('/')[1],
      slug: location.pathname.split('/')[2],
      recommendation: true,
      entryId: id,
    });

    const finalUrl = url || `/topics/${slug}`;
    history.push(finalUrl);
  };

  const imgUrl = getImageFile(fields);

  const classes = useStyles({ imgUrl });

  if (!fields) return null;

  return (
    <ButtonBase onClick={redirect} disableRipple className={classes.container}>
      <Grid
        item
        xs={12}
        className={_classNames({
          [classes.root]: true,
          [classes.bigCardRoot]: isBigCard,
        })}
      >
        <div
          className={_classNames({
            [classes.bigCardImgWrapper]: isBigCard,
          })}
        >
          <div
            className={_classNames({
              [classes.imgBG]: true,
              [classes.bigCardImgBG]: isBigCard,
            })}
          ></div>
        </div>
        <div
          className={_classNames({
            [classes.info]: true,
            [classes.bigCardInfo]: isBigCard,
          })}
        >
          <div className={classes.badgeWrapper}>
            <Badge type="topic" data={fields} removeMargin />
          </div>
          <Typography
            className={_classNames({
              [classes.title]: true,
              [classes.bigCardTitle]: isBigCard,
            })}
            align="left"
            color="textPrimary"
            gutterBottom
          >
            {title || name || article}
          </Typography>
          <Typography
            className={classes.description}
            color="textPrimary"
            align="left"
          >
            {description}
          </Typography>
        </div>
      </Grid>
    </ButtonBase>
  );
};

HorizontalTopicCard.propTypes = {
  item: PropTypes.object,
  isBigCard: PropTypes.bool,
};

export default HorizontalTopicCard;
